<template>
	<div
		class="card relative text-white max-w-sm md:max-w-md lg:max-w-lg xl:max-w-lg mx-auto p-[24px] lg:p-8 lg:pb-14 flex flex-col gap-4"
		:class="border ? 'card-border' : ''"
	>
		<div
			v-if="dealText"
			class="absolute top-[-23px] right-[6%]"
		>
			<span
				class="deal-badge inline-block text-lg text-black px-3 py-2 rounded-md font-bold"
			>
				{{ dealText }}
			</span>
		</div>
		<div class="w-full text-center card-top mb-4">
			<h4 class="text-xl text-black md:text-2xl font-bold">
				{{ title }}
			</h4>
		</div>
		<div class="w-full text-center mb-6">
			<span class="block text-[48px] md:text-[54px] font-bold mb-2 text-black">
				{{ price }}
			</span>
			<span
				v-if="textPriceStyle == 'badge'"
				class="inline-block text-lg font-light text-white bg-blue-300 px-2 py-1 rounded-md"
			>
				{{ textPrice }}
			</span>
			<span
				v-else
				class="block text-[20px] font-light text-slate-500"
			>
				{{ textPrice }}
			</span>
			<p
				class="mt-6 text-black text-lg"
				v-html="text"
			></p>
		</div>
		<CtaButton
			class="mt-14"
			:height="66"
			:full-width="true"
			:to="button.link ? button.link : '#'"
			:type="ctaAppearence || 'gradient-light'"
			:blank="true"
			:data-cta-type="dataCtaType"
		>
			{{ button.title }}
		</CtaButton>
	</div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
	title: String,
	dealText: String,
	dataCtaType: String,
	button: Object,
	price: String,
	textPrice: String,
	textPriceStyle: String,
	text: String,
	ctaAppearence: String,
	border: Boolean
});
</script>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;
.deal-badge {
	background: var(
		--gradient,
		linear-gradient(90deg, #50b5ff 0%, #be55ff 99.95%)
	);
}
.card {
	position: relative;
	height: 100%;
	background: #ffffff;
	background-clip: padding-box;
	border-radius: 1em;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.card-border {
	$border: 4px;
	border: solid $border transparent;
	&:before {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: -1;
		margin: -$border;
		border-radius: inherit;
		background: linear-gradient(to right, $blue-300, $pink);
	}
}
</style>
